import { MutationTree } from "vuex";
import { IContentProvider } from "@/models/contentprovider";
import { IContentProviderState, getDefaultCPState } from ".";

export const mutations: MutationTree<IContentProviderState> = {
    setContentProviders(state, payload: IContentProvider[]) {
        state.error = null;
        state.contentProvidersList = [...payload];
    },
    setSelectedContentProvider(state, payload: IContentProvider) {
        state.isSelectedContentProvider = !!payload;
        state.selectedContentProvider = payload;
    },
    contentProvidersError(state, payload: any) {
        state.error = payload;
    },
    resetState(state) {
        Object.assign(state, getDefaultCPState());
    },
};
